define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PermitTypeDomain = void 0;
    class PermitTypeDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: PermitTypeDomain.TravelPermit, value: "Travel Permit" },
                    { key: PermitTypeDomain.GrazingPermit, value: "Grazing Permit" },
                    { key: PermitTypeDomain.HarvestingPermit, value: "Harvesting Permit" },
                    { key: PermitTypeDomain.GrazingAuthority, value: "Grazing Authority" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[PermitTypeDomain.TravelPermit] = 0;
                this.KeyIndex[PermitTypeDomain.GrazingPermit] = 1;
                this.KeyIndex[PermitTypeDomain.HarvestingPermit] = 2;
                this.KeyIndex[PermitTypeDomain.GrazingAuthority] = 3;
                this.ValueIndex = {};
                this.ValueIndex["Travel Permit"] = 0;
                this.ValueIndex["Grazing Permit"] = 1;
                this.ValueIndex["Harvesting Permit"] = 2;
                this.ValueIndex["Grazing Authority"] = 3;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.PermitTypeDomain = PermitTypeDomain;
    Object.defineProperty(PermitTypeDomain, "TravelPermit", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(PermitTypeDomain, "GrazingPermit", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(PermitTypeDomain, "HarvestingPermit", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(PermitTypeDomain, "GrazingAuthority", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(PermitTypeDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
